<template>
    <div>
        <div class="flex search-box">
            <el-cascader v-model="goods_cate_ids" :options="cates" :props="{value:'id',label:'title'}" clearable
                placeholder="全部分类">
            </el-cascader>
            <el-select v-model="brand_id" placeholder="全部品牌" clearable>
                <el-option :value="item.id" :label="item.title" v-for="(item,index) in brands" :key="index"></el-option>
            </el-select>
            <el-input v-model="kw" placeholder="关键词查询" clearable style="width: 200px;"></el-input>
            <el-button type="primary" @click="_goods">搜索</el-button>
        </div>
        <div class="goods-list">

            <div v-for="(item,index) in goods" :key="index" @click="_change(index)" class="item">
                {{item.title}}
            </div>
        </div>
        <!-- <el-select v-model="goods_index" filterable remote reserve-keyword placeholder="请输入关键词搜索"
            :remote-method="_search" :loading="loading" @change="_change">
            <el-option v-for="(item,index) in goods" :key="index" :label="item.title" :value="index">
            </el-option>
        </el-select> -->
    </div>
</template>
<script>
    export default {
        props: {
            add: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
        computed: {
            watch_str() {
                if (!this.kw) {
                    return;
                }
                let str = this.goods_cate_ids.join('_');
                return str + '_' + this.brand_id + '_' + this.kw;
            }
        },
        watch: {
            watch_str() {
                // this._goods();
            }
        },
        data() {
            return {
                goods: [],
                goods_cate_ids: [],
                cates: [],
                brand_id: '',
                brands: [],
                kw: ''
            }
        },
        created() {
            this._cates();
            this._brands();
        },
        methods: {
            _goods() {
                if (!this.kw) {
                    this._msg('请输入关键词查询', 0);
                    return;
                }
                this.$http.post('goods/list', {
                    goods_cate_ids: this.goods_cate_ids,
                    brand_id: this.brand_id,
                    kw: this.kw,
                    ...this.add,
                    is_sale: 1,
                    limit: 100,
                }).then(res => {
                    this.goods = res.data.data;
                })
            },
            _brands() {
                this.$http.post('brand/list', {
                    order: {
                        myorder: 'desc',
                        id: 'asc'
                    },
                    limit: 100
                }).then(res => {
                    this.brands = res.data.data;
                })
            },
            _cates() {
                this.$http.post('goods_cate/tree').then(res => {
                    this.cates = res.data;
                })
            },
            _change(e) {
                this.$emit('change', this.goods[e]);
            },
        }
    }
</script>
<style lang="scss" scoped>
    @import "index.scss";
</style>